import * as React from 'react';
import Checkbox from 'material-ui/Checkbox';
import * as cx from 'classnames';
import './EhSelector.scss';

export function EhSelector({ values, onChange }) {
    function handleClick(e) {
        const set = new Set(values);

        if (e.target.checked) {
            set.add(e.target.dataset.eh);
        } else {
            set.delete(e.target.dataset.eh);
        }
        onChange(Array.from(set));
    }

    return (
        <div className={cx('eh-selector')}>
            <h3 className="title">From: </h3>
            <Checkbox
                label='Fix'
                data-eh="fix"
                checked={values.includes('fix')}
                onCheck={handleClick}
            />
            <Checkbox
                label='Varamar'
                data-eh="varamar"
                checked={values.includes('varamar')}
                onCheck={handleClick}
            />
            <Checkbox
                label='Fixture'
                data-eh="fixture"
                checked={values.includes('fixture')}
                onCheck={handleClick}
            />
            <Checkbox
                label='Api'
                data-eh="api"
                checked={values.includes('api')}
                onCheck={handleClick}
            />
            <Checkbox
                label='Broker'
                data-eh="broker"
                checked={values.includes('broker')}
                onCheck={handleClick}
            />
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Base/EhSelector/EhSelector.jsx